// @copyright  2006-2023 West Indies Software Engineering Company Limited. All rights reserved.
import tasks from './project-checklist-tasks.js';

export default [
    {
        path: '/:organisation/projects/projects/:id/project-checklists/archive',
        component: () =>
            import('@/pages/[organisation]/projects/projects/[id]/project-checklists/archive.vue'),
        name: 'project-management.project-checklists.archived-project-checklists',
        meta: {
            loginRequired: true,
            permission: 'access.project.project-checklist.update-project-checklist',
        },
        children: [
            {
                path: ':checklistId',
                component: () =>
                    import('@/pages/[organisation]/projects/projects/[id]/project-checklists/archive/[checklistId].vue'),
                name: 'project-management.project-checklists.view-archived-project-checklist',
                meta: {
                    loginRequired: true,
                    permission: 'access.project.project-checklist.update-project-checklist',
                },
            },
            {
                path: ':checklistId/checklist-tasks/:taskId',
                component: () =>
                    import(/* webpackChunkName: "project-management.project-checklist-tasks" */ '@/pages/[organisation]/projects/project-checklist-tasks/plain-checklist-task/[id].vue'),
                name: 'project-management.project-checklist-tasks.view-plain-archived-checklist-task',
                meta: {
                    loginRequired: true,
                    permission: 'access.project.project-checklist-tasks.view-project-checklist-tasks',
                },
            },
        ],
    },

    {
        path: '/:organisation/projects/projects/:id/project-checklists/bin',
        component: () =>
            import('@/pages/[organisation]/projects/projects/[id]/project-checklists/bin.vue'),
        name: 'project-management.project-checklists.binned-project-checklists',
        meta: {
            loginRequired: true,
            permission: 'access.project.project-checklist.archive-project-checklists',
        },
        children: [
            {
                path: ':checklistId',
                component: () =>
                    import('@/pages/[organisation]/projects/projects/[id]/project-checklists/bin/[checklistId].vue'),
                name: 'project-management.project-checklists.view-binned-project-checklist',
                meta: {
                    loginRequired: true,
                    permission: 'access.project.project-checklist.archive-project-checklists',
                },
            },
            {
                path: ':checklistId/checklist-tasks/:taskId',
                component: () =>
                    import(/* webpackChunkName: "project-management.project-checklist-tasks" */ '@/pages/[organisation]/projects/project-checklist-tasks/plain-checklist-task/[id].vue'),
                name: 'project-management.project-checklist-tasks.view-plain-binned-checklist-task',
                meta: {
                    loginRequired: true,
                    permission: 'access.project.project-checklist-tasks.view-project-checklist-tasks',
                },
            },
        ],
    },

    {
        path: '/:organisation/projects/projects/:id/project-checklists',
        component: () =>
            import('@/pages/[organisation]/projects/projects/[id]/project-checklists.vue'),
        name: 'project-management.project-checklists.search-project-checklists',
        meta: {
            loginRequired: true,
            permission: 'access.project.project-checklist.view-project-checklists',
        },

        children: [
            {
                path: 'new',
                component: () =>
                    import('@/pages/[organisation]/projects/projects/[id]/project-checklists/new.vue'),
                name: 'project-management.project-checklists.create-project-checklist',
                meta: {
                    loginRequired: true,
                    permission: 'access.project.project-checklist.create-project-checklist',
                },
            },
            {
                path: ':checklistId',
                component: () =>
                    import(/* webpackChunkName: "project-management.project-checklists" */ '@/pages/[organisation]/projects/project-checklists/project-checklist/[id].vue'),
                name: 'project-management.project-checklists.view-project-checklist',
                meta: {
                    loginRequired: true,
                    permission: 'access.project.project-checklist.view-project-checklists',
                },
            },
            {
                path: ':checklistId/edit',
                component: () =>
                    import(/* webpackChunkName: "project-management.project-checklists" */ '@/pages/[organisation]/projects/project-checklists/project-checklist/[id]/edit.vue'),
                name: 'project-management.project-checklists.update-project-checklist',
                meta: {
                    loginRequired: true,
                    permission: 'access.project.project-checklist.update-project-checklist',
                },
            },
            ...tasks,
        ],
    },
];
